export const ExpiringPurchasedServices = {
  en: {
    'Expiring Purchased Services': 'Expiring Purchased Services',
    Services: 'Services',
  },
  ru: {
    'Expiring Purchased Services': 'Истекающие приобретённые сервисы',
    Services: 'Сервисы',
  },
  uk: {
    'Expiring Purchased Services': 'Придбані сервіси, які закінчуються',
    Services: 'Сервіси',
  },
};
